var React = require('react');

function Mentor (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"#FF007A","d":"M16,8l-1.8-2l0.2-2.7l-2.6-0.6l-1.4-2.3L8,1.4L5.5,0.4L4.2,2.7L1.5,3.3L1.8,6L0,8l1.8,2l-0.2,2.7l2.6,0.6\n\t\tl1.4,2.3L8,14.6l2.5,1.1l1.4-2.3l2.6-0.6L14.2,10L16,8z","key":0}),React.createElement("path",{"d":"M8,10.2l2.6,1.6L9.9,8.8l2.3-2l-3-0.3L8,3.8L6.8,6.6l-3,0.3l2.3,2l-0.7,2.9L8,10.2z","fill":"#FFFFFF","key":1})]);
}

Mentor.defaultProps = {"version":"1.1","x":"0px","y":"0px","viewBox":"0 0 16 16","style":{"enableBackground":"new 0 0 16 16"},"xmlSpace":"preserve"};

module.exports = Mentor;

Mentor.default = Mentor;
